/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsStopwatch: {
  name: 'stopwatch';
  data: string;
} = {
  name: 'stopwatch',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 1A.5.5 0 0 1 6 .5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm-3 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM8 2.5a6.5 6.5 0 1 0 5.37 2.837l.984-.983a.5.5 0 0 0-.708-.708l-.906.907A6.482 6.482 0 0 0 8 2.5ZM8.5 6a.5.5 0 0 0-1 0v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 0-1H8.5V6Z" fill="currentColor"/></svg>`,
};
